import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

const FONT_SANS = "'Geist', 'SF Pro Display', -apple-system, sans-serif";
const FONT_MONO = "'Geist Mono', 'SF Mono', monospace";
const API = '/api/chamas';

// REPLACE entire ChamaTrading export default with:

export default function ChamaTrading({ chamaId, onBack }) {
  const { T } = useTheme();
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');

  useEffect(() => { fetchTrades(); }, [chamaId]);

  const fetchTrades = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/${chamaId}/trades`, { headers: { Authorization: `Bearer ${token}` } });
      const d = await res.json();
      setTrades(d.trades || []);
    } finally { setLoading(false); }
  };

  const card = { background: T.surface, border: `1px solid ${T.border}`, borderRadius: 12 };

  return (
    <div style={{ minHeight: '100vh', background: T.bg, fontFamily: FONT_SANS, color: T.text }}>
      <style>{`@keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}`}</style>

      <nav style={{
        position: 'sticky', top: 0, zIndex: 100, height: 56,
        display: 'flex', alignItems: 'center', padding: '0 32px',
        background: `${T.bg}ee`, backdropFilter: 'blur(16px)',
        borderBottom: `1px solid ${T.border}`,
      }}>
        <button onClick={onBack} style={{
          fontSize: 13, color: T.textMuted, padding: '6px 14px', borderRadius: 8,
          border: `1px solid ${T.border}`, background: T.surface, cursor: 'pointer',
          fontFamily: FONT_SANS, display: 'flex', alignItems: 'center', gap: 6,
        }}>← Back</button>
      </nav>

      <div style={{ maxWidth: 760, margin: '0 auto', padding: '32px 24px 80px', animation: 'fadeIn 0.4s ease' }}>
        <div style={{ marginBottom: 28 }}>
          <h1 style={{ color: T.text, fontSize: 22, fontWeight: 700, margin: '0 0 4px', letterSpacing: '-0.02em' }}>Trade History</h1>
          <p style={{ color: T.textMuted, fontSize: 14, margin: 0 }}>All trades placed by this chama</p>
        </div>

        <div style={{ ...card, overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: `1px solid ${T.border}` }}>
            <p style={{ margin: 0, fontSize: 10, fontWeight: 500, letterSpacing: '0.14em', textTransform: 'uppercase', color: T.textDim }}>
              {trades.length} trade{trades.length !== 1 ? 's' : ''}
            </p>
          </div>
          {loading ? (
            <div style={{ padding: 32, textAlign: 'center', color: T.textDim, fontSize: 13 }}>Loading...</div>
          ) : trades.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: T.textDim, fontSize: 14 }}>
              No trades yet. Go to Markets to place the first chama trade.
            </div>
          ) : trades.map((t, i) => <TradeRow key={t.id} trade={t} index={i} T={T} />)}
        </div>
      </div>
    </div>
  );
}

function TradeRow({ trade, index, T }) {
  const statusColor = { open: T.accent, won: T.yes, lost: T.no, sold: T.gold }[trade.status] || T.textDim;
  const outcomeColor = trade.outcome === 'YES' ? T.yes : trade.outcome === 'NO' ? T.no : T.accent;
  return (
    <div style={{
      display: 'grid', gridTemplateColumns: '1fr auto auto auto', alignItems: 'center', gap: 12,
      padding: '12px 20px', borderBottom: `1px solid ${T.border}`, transition: 'background 0.15s',
    }}
      onMouseEnter={e => e.currentTarget.style.background = T.surfaceHi}
      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
      <div>
        <div style={{ color: T.text, fontSize: 13, fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{trade.market_title}</div>
        <div style={{ color: T.textDim, fontSize: 11, marginTop: 2 }}>by {trade.placed_by} · {new Date(trade.created_at).toLocaleDateString('en-KE', { month: 'short', day: 'numeric' })}</div>
      </div>
      <div style={{ color: outcomeColor, fontSize: 11, fontWeight: 700, background: `${outcomeColor}14`, border: `1px solid ${outcomeColor}28`, borderRadius: 5, padding: '2px 8px' }}>{trade.outcome}</div>
      <div style={{ color: T.text, fontFamily: FONT_MONO, fontSize: 13, fontWeight: 600 }}>KES {parseFloat(trade.amount).toLocaleString()}</div>
      <div style={{ color: statusColor, fontSize: 11, fontWeight: 600, background: `${statusColor}14`, border: `1px solid ${statusColor}28`, borderRadius: 5, padding: '2px 8px', textTransform: 'capitalize', textAlign: 'center' }}>{trade.status}</div>
    </div>
  );
}